import { cn } from '../../../../lib/utils';
import type { CardListBlock } from '../chat-content';
import { CardBlockRenderer } from './card-block';

export function CardListBlockRenderer({ block }: { block: CardListBlock }) {
  const isGrid = block.layout !== 'list';

  return (
    <div className="w-full space-y-2">
      {block.heading && (
        <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground px-0.5">
          {block.heading}
        </p>
      )}
      <div className={cn(isGrid ? 'grid gap-3 grid-cols-1 sm:grid-cols-2' : 'flex flex-col gap-3')}>
        {block.items.map((card, i) => (
          <CardBlockRenderer key={i} block={card} />
        ))}
      </div>
    </div>
  );
}
